import actionCreatorFactory from "typescript-fsa"

const actionCreator = actionCreatorFactory()

interface DriverScopeIf {
  "IT-A自動車-特定特約コード": string
}
// Reduxの被保険者情報state更新アクション
export const userInfoActions = {
  updateContractorAge: actionCreator<string>("ACTIONS_UPDATE_CONTRACTOR_AGE"),
  updateYoungestAge: actionCreator<string>("ACTIONS_UPDATE_YOUNGEST_AGE"),
  updateLicenceColor: actionCreator<string>("ACTIONS_UPDATE_LICENCE_COLOR"),
  updatePurpose: actionCreator<string>("ACTIONS_UPDATE_PURPOSE"),
  updateDistance: actionCreator<string>("ACTIONS_UPDATE_DISTANCE"),
  updateLocation: actionCreator<string>("ACTIONS_UPDATE_LOCATION"),
  updateDriverScope: actionCreator<Array<DriverScopeIf>>("ACTIONS_UPDATE_DRIVER_SCOPE"),
  updateDriverSelect: actionCreator<any>("ACTIONS_UPDATE_DRIVER_SELECT"),
  updateHadAccidents: actionCreator<string>("ACTIONS_UPDATE_HAD_ACCIDENTS"),
  updateNonFleetGrade: actionCreator<string>("ACTIONS_UPDATE_NON_FLEET_GRADE"),
  updateHasAEB: actionCreator<string>("ACTIONS_UPDATE_HAS_AEB"),
  updateGradeDownAccident: actionCreator<string>("ACTIONS_UPDATE_GRADE_DOWN_ACCIDENT"),
  updateHadAccidentSelect: actionCreator<string>("ACTIONS_UPDATE_HAD_ACCIDENT_SELECT"),
  reset: actionCreator("ACTIONS_USER_INFO_RESET")
}

export default userInfoActions
